// extracted by mini-css-extract-plugin
module.exports = {"table":"ActiveIncidentCountsTile_table__1Sqv9","index":"ActiveIncidentCountsTile_index__Flk6x"};